<template>
  <vs-card actionable class="cardx crews-assignable-card">
    <div @click="cardCicked()">
      <!-- 船員名、スコア -->
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-w="10" class="name">
          {{ crewName }}
        </vs-col>
        <vs-col vs-w="2">
          <template>
            <vx-tooltip-with-slot-text position="left">
              <template v-slot:text>
                <ul class="score-content">
                  <li v-for="(scoreInfo, index) in scoringInfos" :key="index">
                    <span class="icon-wrapper">
                      <img :src="scoreIcon(scoreInfo.score)" />
                    </span>
                    <span class="categorie">{{
                      scoreCategorieLabel(scoreInfo.category_id)
                    }}</span>
                    <span class="item">{{
                      scoreCategorieItemLabel(
                        scoreInfo.category_id,
                        scoreInfo.category_item_id,
                        scoreInfo.value
                      )
                    }}</span>
                  </li>
                </ul>
              </template>
              <!-- ホバー対象 -->
              <template v-slot:inner>
                <div class="score-container">
                  <span class="score">{{ crew.score }}</span
                  ><span class="score-unit">%</span>
                </div>
              </template>
            </vx-tooltip-with-slot-text>
          </template>
        </vs-col>
      </vs-row>
      <!-- 辞令職 -->
      <vs-col vs-w="12" class="content">
        {{ appointedPositionName }}
      </vs-col>

      <!-- 対応可能役職名, 警告 -->
      <vs-row vs-type="flex" vs-justify="space-between" class="content">
        <vs-col vs-w="8"> 対応可能役職：{{ positionName }} </vs-col>
      </vs-row>

      <!-- ステータス -->
      <vs-row vs-w="12" class="content">
        <vs-col v-if="crew.onboarding"
          >ステータス：乗船中 {{ onbordingDates }}</vs-col
        >
        <vs-col v-else>ステータス：下船中 {{ hoilidayDates }}</vs-col>
      </vs-row>
      <!-- 乗船実績 (船舶) -->
      <vs-row vs-w="12" class="content">
        <vs-col>乗船実績 (船舶)：{{ crew.boarding_days_of_vessel }}日間</vs-col>
      </vs-row>
      <!-- 乗船実績 (船舶 + 役職) -->
      <vs-row vs-w="12" class="content">
        <vs-col
          >乗船実績 (船舶 + 役職)：{{
            crew.boarding_days_of_vessel_role
          }}日</vs-col
        >
      </vs-row>
    </div>
  </vs-card>
</template>
<script>
import {
  EnterpriseCrewsService,
  EnterpriseCrewRoleService,
  EnterpriseAssignmentScoringCategoriesService,
} from "../../../services/master";
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
export default {
  name: "AssignableCrewCard",
  components: {
    VxTooltipWithSlotText,
  },
  props: {
    crew: {
      type: Object,
      required: true,
    },
    vessel: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      crewDetail: null, // 乗組員の詳細情報を格納する
      scoringInfos: [], // 船員のスコア情報
      scoreIcons: {
        upx3: require("@/assets/images/crew-assignment-management/manning-schedule/score/upx3.svg"),
        upx2: require("@/assets/images/crew-assignment-management/manning-schedule/score/upx2.svg"),
        upx1: require("@/assets/images/crew-assignment-management/manning-schedule/score/upx1.svg"),
        even: require("@/assets/images/crew-assignment-management/manning-schedule/score/even.svg"),
        downx1: require("@/assets/images/crew-assignment-management/manning-schedule/score/downx1.svg"),
        downx2: require("@/assets/images/crew-assignment-management/manning-schedule/score/downx2.svg"),
        downx3: require("@/assets/images/crew-assignment-management/manning-schedule/score/downx3.svg"),
      },
    };
  },
  computed: {
    // 船員名
    crewName() {
      return this.crewDetail ? this.crewDetail.name : "";
    },
    // 辞令職名
    appointedPositionName() {
      if (!this.crewDetail) return "";

      const position = this.crewDetail.crew_available_roles.find(
        role => role.is_appointed
      );
      if (!position) return "";
      return this.findPositionName(position.enterprise_crew_role_id);
    },

    // 対応可能役職名
    positionName() {
      if (!this.crewDetail) return "";

      const position = this.crewDetail.crew_available_roles.find(
        role => !role.is_appointed
      );

      if (!position) return "";
      return this.findPositionName(position.enterprise_crew_role_id);
    },

    onbordingDates() {
      const { embarkation_days } = this.crew;
      return this.formatDisplayDates(embarkation_days);
    },

    hoilidayDates() {
      const { total_holiday_days } = this.crew;
      return this.formatDisplayDates(total_holiday_days);
    },

    // スコアのカテゴリ名(スキル(必須),乗船実績（必須）など)
    scoreCategorieLabel() {
      return category_id => {
        const category = EnterpriseAssignmentScoringCategoriesService.findCategoryById(
          category_id
        );
        if (!category) return "";
        return category.label;
      };
    },
    // スコアのカテゴリアイテム名(LV1,設定無しなど)
    scoreCategorieItemLabel() {
      return (category_id, item_id, value) => {
        const category = EnterpriseAssignmentScoringCategoriesService.findCategoryItemById(
          category_id,
          item_id
        );

        if (!category) return "";
        return category.label.replace("{0}", value);
      };
    },

    // スコアアイコン
    scoreIcon() {
      return score => {
        if (25 <= score) {
          return this.scoreIcons.upx3;
        }
        if (10 <= score && score < 25) {
          return this.scoreIcons.upx2;
        }
        if (0 < score && score < 10) {
          return this.scoreIcons.upx1;
        }
        if (score === 0) {
          return this.scoreIcons.even;
        }
        if (-10 < score && score < 0) {
          return this.scoreIcons.downx1;
        }
        if (-25 < score && score <= -10) {
          return this.scoreIcons.downx2;
        }

        return this.scoreIcons.downx3;
      };
    },
  },
  methods: {
    formatDisplayDates(days) {
      const { last_disembark_date, next_disembark_date } = this.crew;

      const formatDate = dateStr => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return "";
        return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
          d.getDate()
        ).padStart(2, "0")}`;
      };

      const last = formatDate(last_disembark_date);
      const next = formatDate(next_disembark_date);
      const durationInDays = days ? `${days}日間` : "";

      if (last && next && days) {
        return `(${last} ~ ${next} ${durationInDays})`;
      }
      if (!last && next && days) {
        return `(~ ${next} ${durationInDays})`;
      }
      if (last && !next && days) {
        return `(${last} ~ ${durationInDays})`;
      }
      if (!last && !next && days && days > 0) {
        return `(${durationInDays})`;
      }
      return `( - )`;
    },
    // カードクリックイベント
    // 親のコンポーネントにクリックされた船員情報を渡す
    cardCicked() {
      this.$emit("crewSelected", this.crew);
    },

    // 役職名を取得するメソッド
    findPositionName(enterprise_crew_role_id) {
      const role = EnterpriseCrewRoleService.findById(enterprise_crew_role_id);
      if (!role) return "";
      return role.name;
    },
    /**
     * 船員の詳細情報を更新するメソッド
     */
    updateCrewInfo() {
      // 船員の詳細情報を取得
      this.crewDetail = EnterpriseCrewsService.findById(this.crew.crew_id);
      this.scoringInfos = !this.crew ? [] : this.crew.scoring_infos;
    },
  },
  mounted() {
    // コンポーネントがマウントされたときに船員の詳細情報を更新
    this.updateCrewInfo();
  },
  updated() {
    // コンポーネントが更新されたときに船員の詳細情報を更新
    this.updateCrewInfo();
  },
};
</script>
<style lang="scss" scoped>
// カードの内容を調整
.crews-assignable-card {
  margin-bottom: 0px !important;
}

.crews-assignable-card {
  :deep(.vs-card--content) {
    margin-bottom: 0px !important;
  }

  .name {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 4px;
  }

  .score-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .score {
    font-size: 2.5em;
    font-weight: bold;
  }

  .score-unit {
    font-size: 2em;
    margin-left: 4px;
  }

  .content {
    font-size: 1.3em;
  }
}

/* スコア詳細tooltipの中身 */
ul.score-content {
  list-style: none;
  padding: 0;
  margin: 0px;
  display: grid;
  /* 修正点1: 3列になるように grid-template-columns を変更 */
  /* アイコン(auto) / カテゴリ(minmax) / アイテム(1fr) */
  grid-template-columns: auto minmax(80px, auto) 1fr;

  gap: 0px 0px;
  /* 列間の隙間（必要に応じて調整してください） */
  align-items: baseline;
  /* テキストのベースラインを揃える */
}

ul.score-content li {
  display: contents;
  /* li自体はグリッドアイテムにならず、その子要素がグリッドに参加 */
}

ul.score-content .icon-wrapper {
  grid-column: 1;
  /* 1列目 */
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  /* アイコンとカテゴリの間のスペース */
  flex-shrink: 0;
  /* アイコンが縮まないようにする */
}

ul.score-content .icon-wrapper img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  /* 画像とテキストの垂直方向の配置を調整 */
}

ul.score-content .categorie {
  grid-column: 2;
  /* 2列目 */
  white-space: nowrap;
  /* カテゴリのテキストが折り返さないようにする */
  /* 必要に応じて overflow-wrap: break-word; などで長い単語の折り返しを許容 */
}

/* 修正点2: ul.score-contentx を ul.score-content に修正 */
ul.score-content .item {
  grid-column: 3;
  /* 3列目 */
  white-space: nowrap;
  /* アイテムのテキストが折り返さないようにする */
}
</style>
